"use strict";
var _a;
const hamburger = document.getElementById('hamburger');
const navMenu = document.querySelector('.nav-menu');
if (hamburger) {
    hamburger.addEventListener('click', () => {
        hamburger.classList.toggle('active');
        navMenu === null || navMenu === void 0 ? void 0 : navMenu.classList.toggle('active');
    });
}
const navbarHeight = ((_a = document.querySelector('.navbar')) === null || _a === void 0 ? void 0 : _a.clientHeight) || 60;
function smoothScrollTo(targetPosition, duration = 1200) {
    const startPosition = window.pageYOffset;
    const distance = targetPosition - startPosition;
    let startTime = null;
    function animation(currentTime) {
        if (startTime === null)
            startTime = currentTime;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        const easing = progress < 0.5
            ? 4 * progress * progress * progress
            : 1 - Math.pow(-2 * progress + 2, 3) / 2;
        window.scrollTo(0, startPosition + distance * easing);
        if (timeElapsed < duration) {
            requestAnimationFrame(animation);
        }
    }
    requestAnimationFrame(animation);
}
document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
        const href = this.getAttribute('href');
        if (href && href !== '#' && href !== '#contact-btn') {
            e.preventDefault();
            if (hamburger && navMenu) {
                hamburger.classList.remove('active');
                navMenu.classList.remove('active');
            }
            const target = document.querySelector(href);
            if (target) {
                const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
                smoothScrollTo(targetPosition, 1200);
            }
        }
    });
});
window.addEventListener('load', () => {
    if (window.location.hash) {
        const target = document.querySelector(window.location.hash);
        if (target) {
            setTimeout(() => {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 100);
        }
    }
});
const observerOptions = {
    threshold: 0.1,
    rootMargin: '0px 0px -100px 0px'
};
const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            const target = entry.target;
            target.style.opacity = '1';
            target.style.transform = 'translateY(0)';
            observer.unobserve(entry.target);
        }
    });
}, observerOptions);
document.querySelectorAll('.service-card, .section-title, .section-subtitle').forEach((element) => {
    element.style.opacity = '0';
    element.style.transform = 'translateY(20px)';
    element.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(element);
});
const contactForm = document.getElementById('contactForm');
if (contactForm) {
    const checkFormValidity = () => {
        const nameInput = document.getElementById('name');
        const emailInput = document.getElementById('email');
        const messageInput = document.getElementById('message');
        const submitButton = contactForm.querySelector('button[type="submit"]');
        const nameValid = nameInput ? nameInput.value.trim().length > 0 : false;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const emailValid = emailInput ? emailRegex.test(emailInput.value.trim()) : false;
        const messageValid = messageInput ? messageInput.value.trim().length > 0 : false;
        const formValid = nameValid && emailValid && messageValid;
        if (submitButton) {
            submitButton.disabled = !formValid;
            submitButton.style.opacity = formValid ? '1' : '0.6';
            submitButton.style.cursor = formValid ? 'pointer' : 'not-allowed';
        }
    };
    const setupFieldValidation = () => {
        const nameInput = document.getElementById('name');
        if (nameInput) {
            const nameWrapper = nameInput.closest('.input-wrapper');
            const validateName = () => {
                const value = nameInput.value.trim();
                const isEmpty = value.length === 0;
                const isValid = value.length > 0;
                if (nameWrapper) {
                    nameWrapper.classList.remove('valid', 'invalid');
                    if (isValid) {
                        nameWrapper.classList.add('valid');
                    }
                    else if (!isEmpty) {
                        nameWrapper.classList.add('invalid');
                    }
                }
                checkFormValidity();
            };
            nameInput.addEventListener('input', validateName);
            nameInput.addEventListener('blur', () => {
                if (nameInput.value.trim().length === 0 && nameWrapper) {
                    nameWrapper.classList.add('invalid');
                }
                validateName();
            });
        }
        const emailInput = document.getElementById('email');
        if (emailInput) {
            const emailWrapper = emailInput.closest('.input-wrapper');
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const validateEmail = () => {
                const value = emailInput.value.trim();
                const isEmpty = value.length === 0;
                const isValid = emailRegex.test(value);
                if (emailWrapper) {
                    emailWrapper.classList.remove('valid', 'invalid');
                    if (isValid) {
                        emailWrapper.classList.add('valid');
                    }
                    else if (!isEmpty) {
                        emailWrapper.classList.add('invalid');
                    }
                }
                checkFormValidity();
            };
            emailInput.addEventListener('input', validateEmail);
            emailInput.addEventListener('blur', () => {
                if (emailInput.value.trim().length === 0 && emailWrapper) {
                    emailWrapper.classList.add('invalid');
                }
                validateEmail();
            });
        }
        const phoneInput = document.getElementById('phone');
        if (phoneInput) {
            const phoneWrapper = phoneInput.closest('.input-wrapper');
            const validatePhone = () => {
                const cleaned = phoneInput.value.replace(/\D/g, '').slice(0, 10);
                if (phoneInput.value !== cleaned)
                    phoneInput.value = cleaned;
                const isEmpty = cleaned.length === 0;
                const isValid = cleaned.length >= 8 && cleaned.length <= 10;
                if (phoneWrapper) {
                    phoneWrapper.classList.remove('valid', 'invalid');
                    if (isValid) {
                        phoneWrapper.classList.add('valid');
                    }
                    else if (!isEmpty) {
                        phoneWrapper.classList.add('invalid');
                    }
                }
            };
            phoneInput.addEventListener('input', validatePhone);
            phoneInput.addEventListener('blur', validatePhone);
        }
        const messageInput = document.getElementById('message');
        if (messageInput) {
            const messageWrapper = messageInput.closest('.input-wrapper');
            const validateMessage = () => {
                const value = messageInput.value.trim();
                const isEmpty = value.length === 0;
                const isValid = value.length > 0;
                if (messageWrapper) {
                    messageWrapper.classList.remove('valid', 'invalid');
                    if (isValid) {
                        messageWrapper.classList.add('valid');
                    }
                    else if (!isEmpty) {
                        messageWrapper.classList.add('invalid');
                    }
                }
                checkFormValidity();
            };
            messageInput.addEventListener('input', validateMessage);
            messageInput.addEventListener('blur', () => {
                if (messageInput.value.trim().length === 0 && messageWrapper) {
                    messageWrapper.classList.add('invalid');
                }
                validateMessage();
            });
        }
    };
    setupFieldValidation();
    checkFormValidity();
    const phoneInput = document.getElementById('phone');
    if (phoneInput) {
        phoneInput.addEventListener('input', () => {
            const cleaned = phoneInput.value.replace(/\D/g, '').slice(0, 10);
            if (phoneInput.value !== cleaned)
                phoneInput.value = cleaned;
        });
    }
    contactForm.addEventListener('submit', async function (e) {
        e.preventDefault();
        const name = document.getElementById('name').value.trim();
        const email = document.getElementById('email').value.trim();
        let phone = document.getElementById('phone').value.trim();
        const message = document.getElementById('message').value.trim();
        const lang = localStorage.getItem('language') || 'en';
        let feedback = contactForm.querySelector('.form-feedback');
        if (!feedback) {
            feedback = document.createElement('div');
            feedback.className = 'form-feedback';
            feedback.style.marginTop = '12px';
            feedback.style.fontSize = '0.95rem';
            contactForm.appendChild(feedback);
        }
        const setFeedback = (text, success = true) => {
            feedback.textContent = text;
            feedback.style.color = success ? '#0b8a3e' : '#c02323';
        };
        const submitButton = contactForm.querySelector('button[type="submit"]');
        if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = lang === 'pt' ? 'Enviando...' : lang === 'it' ? 'Invio...' : 'Sending...';
            setTimeout(() => showToast(lang === 'pt' ? 'Enviando...' : lang === 'it' ? 'Invio...' : 'Sending...'), 500);
        }
        if (phone && /\D/.test(phone)) {
            phone = phone.replace(/\D/g, '').slice(0, 10);
        }
        if (phone.length > 10)
            phone = phone.slice(0, 10);
        if (phone.length > 0 && !/^\d{1,10}$/.test(phone)) {
            setFeedback(lang === 'pt' ? 'Telefone inválido. Insira apenas até 10 dígitos.' : lang === 'it' ? 'Telefono non valido. Inserisci solo fino a 10 cifre.' : 'Invalid phone. Enter up to 10 digits.', false);
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = lang === 'pt' ? 'Enviar Mensagem' : lang === 'it' ? 'Invia Messaggio' : 'Send Message';
            }
            return;
        }
        try {
            const formData = new FormData(this);
            const res = await fetch('/', {
                method: 'POST',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                body: new URLSearchParams(formData).toString()
            });
            if (!res.ok) {
                throw new Error(`Form submission error: ${res.status}`);
            }
            contactForm.classList.add('success');
            setTimeout(() => contactForm.classList.remove('success'), 4200);
            setFeedback(lang === 'pt' ? 'Mensagem enviada com sucesso. Obrigado!' : lang === 'it' ? 'Messaggio inviato con successo. Grazie!' : 'Message sent successfully. Thank you!');
            setTimeout(() => showToast(lang === 'pt' ? 'Mensagem enviada' : lang === 'it' ? 'Messaggio inviato' : 'Message sent'), 500);
            showSuccessModal({
                title: lang === 'pt' ? 'Obrigado!' : lang === 'it' ? 'Grazie!' : 'Thank you!',
                body: lang === 'pt'
                    ? 'Recebemos sua mensagem e entraremos em contato em breve.'
                    : lang === 'it'
                        ? 'Abbiamo ricevuto il tuo messaggio e ti ricontatteremo presto.'
                        : 'We received your message and will get back soon.',
                closeLabel: lang === 'pt' ? 'Fechar' : lang === 'it' ? 'Chiudi' : 'Close'
            });
            this.reset();
            document.querySelectorAll('.input-wrapper').forEach(wrapper => {
                wrapper.classList.remove('valid', 'invalid');
            });
            if (submitButton) {
                submitButton.disabled = true;
                submitButton.style.opacity = '0.6';
                submitButton.style.cursor = 'not-allowed';
            }
        }
        catch (err) {
            console.error('Contact form submit error:', err);
            setFeedback(lang === 'pt' ? 'Erro ao enviar a mensagem. Tente novamente mais tarde.' : lang === 'it' ? 'Errore nell\'invio del messaggio. Riprova più tardi.' : 'Failed to send message. Please try again later.', false);
            setTimeout(() => showToast(lang === 'pt' ? 'Erro ao enviar' : lang === 'it' ? 'Invio fallito' : 'Send failed', false), 500);
        }
        finally {
            if (submitButton) {
                submitButton.textContent = lang === 'pt' ? 'Enviar Mensagem' : lang === 'it' ? 'Invia Messaggio' : 'Send Message';
                checkFormValidity();
            }
        }
    });
}
function showToast(message, success = true, timeout = 3500) {
    let toast = document.querySelector('.site-toast');
    if (!toast) {
        toast = document.createElement('div');
        toast.className = 'site-toast';
        document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.style.background = success ? '#0b8a3e' : '#c02323';
    toast.classList.add('visible');
    setTimeout(() => {
        toast === null || toast === void 0 ? void 0 : toast.classList.remove('visible');
    }, timeout);
}
function showSuccessModal(opts) {
    let overlay = document.querySelector('.contact-modal-overlay');
    let modal = document.querySelector('.contact-modal');
    if (!overlay) {
        overlay = document.createElement('div');
        overlay.className = 'contact-modal-overlay';
        document.body.appendChild(overlay);
    }
    if (!modal) {
        modal = document.createElement('div');
        modal.className = 'contact-modal';
        modal.innerHTML = `
      <button class="contact-modal-close" aria-label="Close">×</button>
      <h3 class="contact-modal-title"></h3>
      <p class="contact-modal-body"></p>
    `;
        document.body.appendChild(modal);
    }
    const titleEl = modal.querySelector('.contact-modal-title');
    const bodyEl = modal.querySelector('.contact-modal-body');
    const closeBtn = modal.querySelector('.contact-modal-close');
    titleEl.textContent = opts.title;
    bodyEl.textContent = opts.body;
    closeBtn.textContent = '×';
    closeBtn.setAttribute('title', opts.closeLabel);
    const closeModal = () => {
        overlay === null || overlay === void 0 ? void 0 : overlay.classList.remove('visible');
        modal === null || modal === void 0 ? void 0 : modal.classList.remove('visible');
        document.removeEventListener('keydown', onKey);
    };
    const onKey = (e) => {
        if (e.key === 'Escape')
            closeModal();
    };
    overlay.classList.add('visible');
    modal.classList.add('visible');
    document.addEventListener('keydown', onKey);
    closeBtn.onclick = closeModal;
    overlay.onclick = closeModal;
    closeBtn.focus();
}
function formatContactPhone() {
    const phoneAnchor = document.querySelector('.contact-info a[href^="tel:"]');
    if (!phoneAnchor)
        return;
    const href = phoneAnchor.getAttribute('href') || '';
    const digits = href.replace(/\D/g, '');
    if (digits.length === 10) {
        const formatted = `${digits.slice(0, 4)} ${digits.slice(4, 7)} ${digits.slice(7, 10)}`;
        phoneAnchor.textContent = formatted;
    }
}
formatContactPhone();
window.addEventListener('scroll', () => {
    const navbar = document.querySelector('.navbar');
    if (!navbar)
        return;
    if (window.scrollY > 50) {
        navbar.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.15)';
    }
    else {
        navbar.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.1)';
    }
});
